/**
 * Activity time log state — replaces the Solid signals from the original CMS codebase.
 * Uses plain module-level state since this runs client-side only and doesn't need reactivity.
 */

interface ActivityTimeLogState {
	ctViewdEventTime: number;
	ctClickEventTime: number;
	viewEventTriggered: boolean;
}

let activityTimeLogState: ActivityTimeLogState = {
	ctViewdEventTime: 0,
	ctClickEventTime: 0,
	viewEventTriggered: false,
};

export const getActivityTimeLogState = (): ActivityTimeLogState => activityTimeLogState;

export const setActivityTimeLogState = (
	updater: (prev: ActivityTimeLogState) => ActivityTimeLogState,
): void => {
	activityTimeLogState = updater(activityTimeLogState);
};
